import { Button, Card, Stack, colors, useLang } from "@manulife/mux";
import { Download, Email } from "@manulife/mux-cds-icons";
import { useSelector } from "react-redux";
import { emailFtChart } from '../../services/helpers/emailTemplate';
import { downloadPDF } from "../../services";
import {  NormalText } from "../../assets/appStyledComponents";
import ResultLables from '../../assets/resultLabels.json';


function RtgDownloadEmail() {

  const selectedLang = useLang();

  const validatedData = useSelector(
    (state) => state.rportReducer?.validatedData
  );

  const reportPdfBase64str = useSelector(
    (state) => state.chartReducer?.chartsData?.illustration?.report?.data || ""
  );

  const chartData = useSelector(
    (state) => state.chartReducer?.chartsData?.illustration?.report?.graph.find(ele => ele.type === "PremiumCompareRenewal")
  );

  const isLoading = useSelector(
    (state) => state.chartReducer?.isLoading
  );

  return chartData ? (
    <>     
      <Card.Content>
        <Stack direction="row">
          <Button
            variant={Button.VARIANT.TERTIARY_NOICON}
            icon={<Download color={colors.m_green} />}
            disabled={isLoading}
            saving={isLoading}
            onClick={() => downloadPDF(reportPdfBase64str)}
          >
            {ResultLables.downloadPDF[`${selectedLang}`].label}
          </Button>
          <Button
            variant={Button.VARIANT.TERTIARY_NOICON}
            icon={<Email color={colors.m_green} />}
            onClick={async () => await emailFtChart({
              ...validatedData,
              isDownloadPDF: true,
              reportType: "PremiumCompare"
            }, selectedLang)}
          >
            {ResultLables.email[`${selectedLang}`].label}
          </Button>
        </Stack>
      </Card.Content>
      <Card.Separator />
      <Card.Content>
        <NormalText>{ResultLables.tabBottomLine[`${selectedLang}`].label}</NormalText>
      </Card.Content>
    
    </>
  ):<></>
};

export default RtgDownloadEmail;
